import React, { useContext, useState } from 'react';
import WomanImg from '../img/contact/woman.png';
import { motion } from 'framer-motion';
import { transition1 } from '../transitions';
import { CursorContext } from '../context/CursorContext';

const Contact = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Input validation and sanitization
    const name = formData.name.trim();
    const email = formData.email.trim();
    const message = formData.message.trim();
    
    if (!name || !email || !message) {
      alert('Please fill in all fields');
      return;
    }
    
    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert('Please enter a valid email address');
      return;
    }
    
    // Sanitize inputs for WhatsApp message (remove potentially harmful characters)
    const sanitizedName = name.replace(/[<>]/g, '');
    const sanitizedEmail = email.replace(/[<>]/g, '');
    const sanitizedMessage = message.replace(/[<>]/g, '');
    
    // Create WhatsApp message
    const whatsappMessage = `Hi! My name is ${sanitizedName} and this is my message:

    ${sanitizedMessage}

    Also, here is my email address: ${sanitizedEmail}`;
    
    // Encode the message for URL
    const encodedMessage = encodeURIComponent(whatsappMessage);
    
    // Your WhatsApp number (replace with your actual number)
    const whatsappNumber = '972505878603'; // Israel number format without +
    
    // Create WhatsApp URL
    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    
    // Open WhatsApp in new tab
    window.open(whatsappURL, '_blank');
    
    // Clear form after successful submission
    setFormData({
      name: '',
      email: '',
      message: ''
    });
  };

  return (
    <motion.section 
      initial={{ opacity: 0, y: '100%' }} 
      animate={{ opacity: 1, y: 0 }} 
      exit={{ opacity: 0, y: '100%' }} 
      transition={transition1} 
      className='section'
    >
      <div className='container mx-auto h-full'>
        <div className='flex flex-col lg:flex-row h-full items-center justify-start pt-36 gap-x-8 text-center lg:text-left'>
          
          <motion.div 
            initial={{ opacity: 0, y: '100%' }} 
            animate={{ opacity: 1, y: 0 }} 
            exit={{ opacity: 0, y: '100%' }} 
            transition={transition1} 
            className='hidden lg:flex bg-secondary absolute bottom-0 left-0 right-0 top-72 -z-10'
          ></motion.div>

          <div 
            onMouseEnter={mouseEnterHandler} 
            onMouseLeave={mouseLeaveHandler} 
            className='lg:flex-1 lg:pt-32 px-4'
          >
            <h1 className='h1'>Contact me</h1>
            <p className='mb-12'>
              I'd love to hear from you! Whether you want to collaborate, hire me for a project, or just say hi, feel free to send me a message below. It will open WhatsApp with your message ready to send.
            </p>
            <form className='flex flex-col gap-y-4' onSubmit={handleSubmit}>
              <div className='flex gap-x-10'>
                <input 
                  className='outline-none border-b border-b-primary h-[60px] bg-transparent font-secondary w-full pl-3 placeholder:text-[#fff]'
                  type='text' 
                  name='name'
                  placeholder='Your name' 
                  value={formData.name}
                  onChange={handleInputChange}
                  maxLength={100}
                  required
                />
                <input 
                  className='outline-none border-b border-b-primary h-[60px] bg-transparent font-secondary w-full pl-3 placeholder:text-[#fff]'
                  type='email' 
                  name='email'
                  placeholder='Your email address' 
                  value={formData.email}
                  onChange={handleInputChange}
                  maxLength={100}
                  required
                />
              </div>
              <input 
                className='outline-none border-b border-b-primary h-[60px] bg-transparent font-secondary w-full pl-3 placeholder:text-[#fff]'
                type='text' 
                name='message'
                placeholder='Your message' 
                value={formData.message}
                onChange={handleInputChange}
                maxLength={500}
                required
              />
              <button type='submit' className='btn mb-[30px] mx-auto lg:mx-0 self-start'>Send it</button>
            </form>
          </div>

          <motion.div 
            onMouseEnter={mouseEnterHandler} 
            onMouseLeave={mouseLeaveHandler} 
            initial={{ opacity: 0, y: '100%' }} 
            animate={{ opacity: 1, y: 0 }} 
            exit={{ opacity: 0, y: '100%' }} 
            transition={{ transition: transition1, duration: 1.5 }} 
            className='lg:flex-1'
          >
            <img src={WomanImg} alt='Contact illustration' />
          </motion.div>

        </div>
      </div>
    </motion.section>
  );
};

export default Contact;